var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNswDots = function SvgNswDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114,
    height: 118,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6EE4FF",
    d: "M9.69 117.82a9.55 9.55 0 1 0 0-19.1 9.55 9.55 0 0 0 0 19.1M103.97 48.76a9.55 9.55 0 1 0 0-19.1 9.55 9.55 0 0 0 0 19.1M61.21 19.26a9.55 9.55 0 1 0 0-19.1 9.55 9.55 0 0 0 0 19.1M51.66 84.14a9.55 9.55 0 1 0 0-19.1 9.55 9.55 0 0 0 0 19.1"
  })));
};
export default SvgNswDots;